module.exports = __webpack_public_path__ + "static/media/carta_91.cca9484b.jpg";